import { Checkbox, Space, Tag, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type ReconcileMatch } from '@webapp/modules/accounts-payable/entities/ReconcileMatch'
import messages from './messages'

export interface IMatchedItemPickerProps {
  matches: ReconcileMatch[]
  selectedItemIds: number[]
  onToggleItem: (itemId: number) => void
}

// Attach-invoice modal CONTENT — a checkbox list of the session's matched
// credit-card items for one uploaded invoice (BHV-048). The ModalDialog
// wrapper and the Cancel / Attach buttons are FS-owned.
export const MatchedItemPicker = ({
  matches,
  selectedItemIds,
  onToggleItem,
}: IMatchedItemPickerProps) => {
  const intl = useProcurifyIntl()

  return (
    <Space>
      <Text autoMargin={false}>
        {intl.formatMessage(messages.instructions)}
      </Text>
      <Space size='small'>
        {matches.map((match) =>
          match.creditcardItems.map((item) => (
            <Space
              key={item.id}
              direction='horizontal'
              justify='space-between'
              align='center'
            >
              <Space direction='horizontal' size='small' align='center'>
                <Checkbox
                  checked={selectedItemIds.includes(item.id)}
                  onChange={() => onToggleItem(item.id)}
                  inputProps={{
                    'aria-label': intl.formatMessage(
                      messages.selectItemAriaLabel,
                      { description: item.descriptionLabel }
                    ),
                  }}
                />
                {item.refLabel && <Tag>{item.refLabel}</Tag>}
                <Text autoMargin={false}>{item.descriptionLabel}</Text>
              </Space>
              <Text bold autoMargin={false}>
                {item.totalCost.toFixed(2)} {item.currency.name}
              </Text>
            </Space>
          ))
        )}
      </Space>
    </Space>
  )
}

MatchedItemPicker.displayName = 'MatchedItemPicker'
